import React, { useEffect } from "react";
import "./contactForm.css";
import { FcCheckmark } from "react-icons/fc"


export default function ContactForm(props) {

    const [formData, setFormData] = React.useState({
        name: "",
        email: "",
        number: "",
        message: ""
    })

    const [isSubmitted, setIsSubmitted] = React.useState(false)

    const closeModal = () => {
        props.handleClick();
        setIsSubmitted(false)
    }

    useEffect(() => {
        if (isSubmitted) {
            setTimeout(closeModal, 1500)
        }
    }, [isSubmitted])

    function handleChange(event) {
        const {name, value} = event.target
        setFormData(prevFormData => {
            return {
                ...prevFormData, [name]: value
            }
        })
    }

    function handleSubmit(event) {
        event.preventDefault();
    
        setIsSubmitted(true);
        
        // Make an AJAX request to the PHP script
        fetch('https://pillarsouthafrica.co.za/server/features/sendEmail.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.text())
        .then(data => {
            console.log(data);
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
    

    return (
        <div className="contactForm" id="contact">
            <div className="modal-background" onClick={props.handleClick}></div>

                <div className="contact-wrapper">
                    <div className="contactForm-text-wrapper div1">
                        <p className="hero-title contact-heading">Contact Us</p>
                    </div>
                
                    {isSubmitted ?
                        <div className="div2 thank-you">
                            <FcCheckmark className="check" />
                            <p className="heading ta-center">Message Received!</p>
                        </div> :
                            
                        <form onSubmit={handleSubmit} className="form-wrapper">
                        <div className="input-wrapper">
                            <div className="input-row">
                                    <input
                                    className="input"
                                    type="text"
                                    name="name"
                                    placeholder="Your name"
                                    value={formData.name}
                                    onChange={handleChange}
                            />
                            </div>
                            
                            
                            <div className="input-row">
                                <input
                                    className="input"
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />    

                            
                                <div className="input-row">
                                           <input
                                    className="input"
                                    type="text"
                                    name="number"
                                    placeholder="Contact Number"
                                    value={formData.number}
                                    onChange={handleChange}
                                /> 
                                </div>
                        
                            </div>
                                    

                            <div className="input-row">
                                        <textarea
                                className="textarea"
                                name="message"
                                placeholder="Your Message"
                                rows={40}
                                value={formData.message}
                                onChange={handleChange}
                                />
                            </div>
                    
                                
                            </div>
                            

                            <button className="btn">Submit</button>
                        </form>
                }
                <div className="compliance-info div3">
                    <div className="compliance-heading compliance-line"><strong>Compliance Information</strong></div>
                    <div className="compliance-grid">
                        <div className="compliance-line"><strong>Full Registered Name:</strong><br /><span className="compliance-text">Pillar South Africa<br />Administrative Solution(PTY) LTD</span></div>
                    <div className="compliance-line"><strong>BEE Status:</strong><br /><span className="compliance-text">Level 1</span></div>
                    <div className="compliance-line"><strong>Registration Number:</strong><br /><span className="compliance-text">2018/621961/07</span></div>
                    <div className="compliance-line"><strong>CSD Supplier Name:</strong><br /><span className="compliance-text">MAAA0850764</span></div>
                    </div>
                    
                         </div>
                    
                </div>
            
        </div>     
    )
}